import { render } from "./TieBossKayaksHome.vue?vue&type=template&id=1287a34c"
import script from "./TieBossKayaksHome.vue?vue&type=script&lang=js"
export * from "./TieBossKayaksHome.vue?vue&type=script&lang=js"

import "./TieBossKayaksHome.vue?vue&type=style&index=0&id=1287a34c&lang=scss"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__